import React, { useEffect, useRef } from 'react'
import { View, Animated, StyleSheet } from 'react-native'
import theme from '../../../theme'

export const LoadingDots = ({ style = null, dotStyle = null }) => {
    const dot1 = useRef(new Animated.Value(0)).current
    const dot2 = useRef(new Animated.Value(0)).current
    const dot3 = useRef(new Animated.Value(0)).current

    useEffect(() => {
        const animate = (dot, delay) => {
            Animated.loop(
                Animated.sequence([
                    Animated.delay(delay),
                    Animated.timing(dot, {
                        toValue: 1,
                        duration: 400,
                        useNativeDriver: true,
                    }),
                    Animated.timing(dot, {
                        toValue: 0,
                        duration: 400,
                        useNativeDriver: true,
                    }),
                ]),
            ).start()
        }

        animate(dot1, 0)
        animate(dot2, 150)
        animate(dot3, 300)
    }, [])

    const interpolate = (dot) => ({
        opacity: dot.interpolate({ inputRange: [0, 1], outputRange: [0.3, 1] }),
        transform: [
            {
                scale: dot.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0.8, 1.2],
                }),
            },
        ],
    })

    return (
        <View style={[styles.container, style && style]}>
            <Animated.View
                style={[styles.dot, dotStyle && dotStyle, interpolate(dot1)]}
            />
            <Animated.View
                style={[styles.dot, dotStyle && dotStyle, interpolate(dot2)]}
            />
            <Animated.View
                style={[styles.dot, dotStyle && dotStyle, interpolate(dot3)]}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    dot: {
        width: 10,
        height: 10,
        backgroundColor: theme.colors.colorPrimary,
        borderRadius: 6,
    },
})
